module.exports = __webpack_public_path__ + "static/img/home-mb-select.6cd0628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/home-mb-select.png
// module id = g7m3
// module chunks = 1